import ObjectActionCreators from '../actions';
import { getHost } from '../helper/getHost';
import { openObjectDetails } from '../reducers/layoutReducer/action';
import { onPushAndAutoRemoveNotification } from '../reducers/notificationReducer/action';

// websocketMiddleware.js
export const websocketMiddleware = () => {
  let socket;
  const url = `wss://${getHost()}/guerillaPM3/ws`;

  return ({ dispatch, getState }) =>
    (next) =>
    (action) => {
      switch (action.type) {
        // Action to initiate WebSocket connection
        case 'WEBSOCKET_CONNECT':
          try {
            const instanceId = getState().auth.instanceId;
            const urlWithInstanceId = `${url}?instanceId=${instanceId}`;
            socket = new WebSocket(urlWithInstanceId);
          } catch (error) {
            alert(error);
          }

          // Set up WebSocket event handlers
          socket.onopen = () => {
            dispatch({ type: 'WEBSOCKET_OPEN' });
          };

          socket.onmessage = (event) => {
            const message = JSON.parse(event.data);
            if (message.type === 'questSingleChoice') {
              dispatch({
                type: 'INTERACTION_OPEN',
                payload: {
                  interactionType: message.type,
                  interactionData: {
                    questionId: message.payload.questionId,
                    question: message.payload.question,
                    description: message.payload.description,
                    options: message.payload.options,
                  },
                },
              });
            } else if (message.type === 'questMultChoice') {
              dispatch({
                type: 'INTERACTION_OPEN',
                payload: {
                  interactionType: message.type,
                  interactionData: {
                    questionId: message.payload.questionId,
                    question: message.payload.question,
                    description: message.payload.description,
                    options: message.payload.options,
                  },
                },
              });
            } else if (message.type === 'questConfirmation') {
              dispatch({
                type: 'INTERACTION_OPEN',
                payload: {
                  interactionType: message.type,
                  interactionData: {
                    questionId: message.payload.questionId,
                    question: message.payload.question,
                    description: message.payload.description,
                    options: message.payload.options,
                  },
                },
              });
            } else if (message.type === 'questInput') {
              dispatch({
                type: 'INTERACTION_OPEN',
                payload: {
                  interactionType: message.type,
                  interactionData: {
                    questionId: message.payload.questionId,
                    question: message.payload.question,
                    description: message.payload.description,
                    options: message.payload.options,
                  },
                },
              });
            } else if (message.type === 'showNode') {
              dispatch(
                ObjectActionCreators.selectObject(message.payload.nodeId)
              );
              dispatch(openObjectDetails());
            } else if (message.type === 'aitext') {
              dispatch({
                type: 'INTERACTION_INFO',
                payload: message.payload,
              });
            } else if (message.type === 'aiclose') {
              dispatch({
                type: 'INTERACTION_CLOSED_BY_AI',
                payload: message.payload,
              });
            } else if (message.type === 'aiprogress') {
              dispatch({
                type: 'INTERACTION_PROGRESS_BY_AI',
                payload: message.payload,
              });
            } else if (message.type === 'viewConfiguration') {
              dispatch({
                type: 'VIEW_CONFIGURATION',
                payload: message.payload,
              });
            } else if (message.type === 'viewRestriction') {
              dispatch({
                type: 'VIEW_RESTRICTION',
                payload: message.payload,
              });
            } else {
              dispatch({ type: 'SERVER_MESSAGE', payload: message });

              dispatch(
                onPushAndAutoRemoveNotification({
                  title: `Server message: ${message.type}`,
                  description: message.payload,
                  time: 15000,
                })
              );
            }
          };

          socket.onclose = () => {
            dispatch({ type: 'WEBSOCKET_CLOSE' });
            setTimeout(() => dispatch({ type: 'WEBSOCKET_CONNECT' }), 1000);
          };

          socket.onerror = (error) => {
            dispatch({ type: 'WEBSOCKET_ERROR', payload: error });
          };
          break;

        // Action to send a message via WebSocket
        case 'WEBSOCKET_SEND':
          if (socket) {
            socket.send(JSON.stringify(action.payload));
          }
          break;

        case 'INTERACTION_RESPONSE':
          if (socket && socket.readyState === WebSocket.OPEN) {
            const { questionId, response } = action.payload;

            // Message JSON attendu par le serveur
            const responseMessage = {
              type: 'question_response',
              messageId: questionId, // questionId utilisé comme messageId
              payload: {
                response: response,
              },
            };

            socket.send(JSON.stringify(responseMessage));
          } else {
            console.warn('WebSocket is not connected.');
          }
          return next(action);

        // Pass all other actions through middleware
        default:
          return next(action);
      }
    };
};
